<template>
  <div class="typeCardBox flex-c" @click="goListPath(item)">
    <div class="img">
      <img :src="item.path" alt="" />
    </div>
    <div class="info">
      <div class="name __line1">{{ item.name }}</div>
      <div class="bottom">
        <div class="desc __line1" v-html="item.desc"></div>
        <img
          class="icon"
          src="@/assets/images/arrowRight.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods:{
    goListPath(item) {
      this.$dataStatistics({ event_type: 'click', page_title: '分类' }, JSON.stringify({ title: `${item.name}`, id: item.id }));
      this.$router.push(`/childList?id=${item.id}`);
    },
  }
};
</script>
<style lang="less" scoped>
.typeCardBox {
  padding: 20px;
  padding-right: 30px;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  border: 1px solid #e4e1df;
  margin-bottom: 30px;
  .img {
    width: 250px;
    height: 120px;
    margin-right: 22px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    width: 100%;
    .name {
      font-size: 34px;
      color: #101010;
      font-weight: bold;
      margin-top: 8px;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 7px;
      img {
        width: 26px;
        height: 21px;
      }
      .icon {
        margin-top: 26px;
      }
    }
    .desc {
      font-size: 30px;
      color: rgba(16, 16, 16, 0.8);
    }
  }
}
</style>